import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type TableCellProps = ComponentProps<'td'>;
export const TABLE_CELL_HEIGHT_CLASS = cn('h-12.25');
export const TABLE_CELL_PADDING_CLASS = cn('p-2');

const TableCell = ({ className, ...props }: TableCellProps) => {
  return (
    <td
      data-slot="table-cell"
      className={cn(
        TABLE_CELL_HEIGHT_CLASS,
        TABLE_CELL_PADDING_CLASS,
        'align-middle wrap-break-word whitespace-normal',
        className,
      )}
      {...props}
    />
  );
};

export default TableCell;
